
import { DevicesDto } from "./dto/device.dto";
import { DeviceEntity } from "./entity/device.entity";




export class DevicesAdapater{

    
    constructor() {

    }

    public convertCreateDtoEntity(createDto: DevicesDto): DeviceEntity {

        const entityObj = new DeviceEntity ();
        entityObj.deviceId = createDto.deviceId;
        entityObj.deviceCode = createDto.deviceCode;
        entityObj.description = createDto.description;
        entityObj.deviceName = createDto.deviceName;
        entityObj.createdUser = createDto.username;
        
        return entityObj;
    }
}